import type { ShortcutHandlerContext } from '../../../../../lib/types.js';
import { assertBridgeWorkspace } from '../../../../lib/assert-bridge-workspace.js';
import { handleShortcutFileBrowserList } from '../../../../lib/file-browser/handle-list.js';

/** GET /api/bridges/files/list */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  if (!assertBridgeWorkspace(ctx)) return;
  await handleShortcutFileBrowserList(ctx);
}
